import { useContext } from 'react';

import { FunnelContext } from '../FunnelContext';
import { SettingsContext } from '../SettingsContext';
import { UiContext } from '../UiContext';

export const useFunnel = () => useContext(FunnelContext);
export const useNavigation = () => useContext(UiContext);
export const useSettings = () => useContext(SettingsContext);
